let cachedDirHandle: FileSystemDirectoryHandle | undefined

export async function dirHandle() {
  if (cachedDirHandle) return cachedDirHandle

  const opfsRoot = await navigator.storage.getDirectory()
  cachedDirHandle = await opfsRoot.getDirectoryHandle("mds", {
    create: true,
  })

  return cachedDirHandle
}
